import { NpcObject } from "../objects/npcobject";
import { TYPE_QUEST_REQ_DO_TRIGGER } from "../net/networkconstants";
import { luaConsole } from "../util/logging";

export const QF: any = {};

QF.checkQuestCondition = (triggerName: any) => {
  const questScripts = GDM.getNow('quest_scripts');
  luaConsole.debug('QF_checkQuestCondition(', triggerName, ')');
  const res = questScripts.checkOnly(triggerName);
  luaConsole.debug('QF_checkQuestCondition Result:', res);
  return [ res ? 1 : 0 ];
};

QF.doQuestTrigger = (triggerName: any) => {
  if (QF.checkQuestCondition(triggerName)[0] <= 0) {
    return [ 0 ];
  }

  netGame.questRequest(TYPE_QUEST_REQ_DO_TRIGGER, 0, 0, triggerName);
  return [ 1 ];
};

QF.getEpisodeVAR = (varNo: any) => {
  return [ MC.quests.getEpisodeVar(varNo) ];
};

QF.getJobVAR = (varNo: any) => {
  return [ MC.quests.getJobVar(varNo) ];
};

QF.getPlanetVAR = (varNo: any) => {
  return [ MC.quests.getPlanetVar(varNo) ];
};

QF.getUnionVAR = (varNo: any) => {
  return [ MC.quests.getUnionVar(varNo) ];
};

QF.getUserSwitch = (switchId: any) => {
  return [ MC.quests.getSwitch(switchId) ];
};

QF.getQuestCount = () => {
  return [ MC.quests.getQuestCount() ];
};

QF.findQuest = (id: any) => {
  return [ MC.quests.findQuestByID(id) ];
};

QF.getQuestID = (questNo: any) => {
  return [ MC.quests.getQuestId(questNo) ];
};

QF.getQuestItemQuantity = (questID: any, itemSn: any) => {
  const itemType = Math.floor(itemSn / 1000);
  const itemNo = itemSn % 1000;
  return [ MC.quests.getQuestItemQuantity(questID, itemType, itemNo) ];
};

QF.getQuestSwitch = (questNo: any, id: any) => {
  return [ MC.quests.getQuestSwitch(questNo, id) ];
};

QF.getQuestVar = (questNo: any, id: any) => {
  return [ MC.quests.getQuestVar(questNo, id) ];
};

QF.getEventOwner = (event: any) => {
  return [ event.npc.serverObjectIdx ];
};

QF.getNpcQuestZeroVal = (objectIdx: any) => {
  const obj = GZM.findByServerObjectIdx(objectIdx);

  if (obj instanceof NpcObject) {
    return [ obj.eventVar[0] || 0 ];
  } else {
    return [ 0 ];
  }
};
